(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-custom"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('custom-popup');
  const overlay = popup.querySelector('.popup-overlay');
  const closeBtn = document.getElementById('close-popup');
  const confirmBtn = document.getElementById('confirm-selection');

  // 等待 Shopify Add to Cart / Buy Now 按钮加载
  function bindPopupToButtons() {
    const BUTTON_SELECTORS = [
      '.add-to-cart-button',
      '.product-form__add-to-cart',
      '.product-form__submit',
      'button[name="add"]',
      '.shopify-payment-button__button',
      '.shopify-payment-button__button--unbranded',
      '.buy-now-button',
      '.product-form__buy-now'
    ].join(',');

    const buttons = document.querySelectorAll(BUTTON_SELECTORS);
    if (buttons.length === 0) {
      setTimeout(bindPopupToButtons, 500);
      return;
    }

    buttons.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        // 保存当前点击按钮类型，区分 Buy Now / Add to Cart
        popup.dataset.originButtonType = btn.classList.contains('buy-now-button') || btn.classList.contains('product-form__buy-now') ? 'buy-now' : 'add-to-cart';
        popup.dataset.originButton = btn; // 保存原按钮
        popup.style.display = 'flex';
      });
    });
  }

  bindPopupToButtons();

  // 弹窗关闭
  function closePopup() {
    popup.style.display = 'none';
  }
  closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', closePopup);

  // 确定按钮点击
  confirmBtn.addEventListener('click', function() {
    const selected = document.querySelector('input[name="diamond_color"]:checked');
    if (!selected) {
      alert('Please select a diamond color!');
      return;
    }

    // 找到 Add to Cart / Buy Now 表单
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    // 查找或创建隐藏 input
    let hiddenInput = form.querySelector('#diamond-color-property');
    if (!hiddenInput) {
      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'properties[Diamond Color]';
      hiddenInput.id = 'diamond-color-property';
      form.appendChild(hiddenInput);
    }

    // 写入选中值
    hiddenInput.value = selected.value;

    // 关闭弹窗
    popup.style.display = 'none';

    // 根据点击来源决定行为
    if (popup.dataset.originButtonType === 'buy-now') {
      // 立即购买：提交表单 + 跳转到结账
      const variantId = form.querySelector('input[name="id"]').value;
      const properties = {};
      form.querySelectorAll('input[name^="properties"]').forEach(p => {
        const key = p.name.match(/\[([^\]]+)\]/)[1];
        properties[key] = p.value;
      });

      // 用 Shopify Ajax API 添加并跳转结账
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties }] })
      })
      .then(res => res.json())
      .then(() => {
        window.location.href = '/checkout';
      })
      .catch(() => alert('Failed to add to checkout.'));
    } else {
      // 普通 Add to Cart
      form.submit();
    }
  });
});







  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
(function () {
  // 获取 header 元素
  var header = document.querySelector('#header-component') || document.querySelector('header');

  if (!header) return;

  function updateHeaderHeight() {
    var h = header.offsetHeight || header.getBoundingClientRect().height || 0;
    document.documentElement.style.setProperty('--header-height', h + 'px');
  }

  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight);
  window.addEventListener('orientationchange', updateHeaderHeight);

  // 如果 header 高度会动态变化，可以用 ResizeObserver
  if ('ResizeObserver' in window) {
    new ResizeObserver(updateHeaderHeight).observe(header);
  }
})();



(function() {
  if (window.innerWidth > 749) return; // 仅手机端

  document.addEventListener('DOMContentLoaded', function () {
    const wrapper = document.querySelector('.product-information__media-wrapper');
    if (!wrapper) return;

    const slides = Array.from(wrapper.children);
    if (slides.length === 0) return;

    // 创建小圆点
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'carousel-dots-container';
    const dots = slides.map((_, i) => {
      const dot = document.createElement('div');
      dot.className = 'carousel-dot';
      if(i === 0) dot.classList.add('active');

      dot.addEventListener('click', () => {
        wrapper.scrollLeft = i * wrapper.clientWidth; // 立即切换
        updateDots(i);
      });

      dotsContainer.appendChild(dot);
      return dot;
    });

    wrapper.parentElement.appendChild(dotsContainer);

    // 更新圆点
    function updateDots(i) {
      dots.forEach((dot, j) => {
        dot.classList.toggle('active', i === j);
      });
    }

    // 手指拖拽
    let isDown = false, startX, scrollLeft;
    wrapper.addEventListener('pointerdown', function(e){
      isDown = true;
      wrapper.setPointerCapture(e.pointerId);
      startX = e.clientX;
      scrollLeft = wrapper.scrollLeft;
    });
    wrapper.addEventListener('pointermove', function(e){
      if(!isDown) return;
      wrapper.scrollLeft = scrollLeft + (startX - e.clientX);
    });
    wrapper.addEventListener('pointerup', function(){ isDown = false; });
    wrapper.addEventListener('pointercancel', function(){ isDown = false; });

    // 滑动时实时更新圆点
    wrapper.addEventListener('scroll', function () {
      const i = Math.round(wrapper.scrollLeft / wrapper.clientWidth);
      updateDots(i);
    });
  });
})();


  } catch(e) { console.error(e); }
})();
})();
